var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGameBanner7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 549,
    viewBox: "0 0 390 549",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.5 549C498.771 549 743 422.744 743 267C743 111.256 498.771 -21 197.5 -21C-103.771 -21 -348 111.256 -348 267C-348 422.744 -103.771 549 197.5 549Z",
    fill: "url(#paint0_linear_43_11)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_11",
    x1: 197.5,
    y1: -15,
    x2: 197.5,
    y2: 549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D47F",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 549,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameBanner7);
export default __webpack_public_path__ + "static/media/gameBanner7.7abab8ae5791ebcfe9228dc573491592.svg";
export { ForwardRef as ReactComponent };